import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import gql from 'graphql-tag';
import { defaultApolloClient } from '@/vue-apollo';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';
import {
  like,
  and,
} from '@/classes/pimcore-filtering/Filters';
import { TemplatesState } from './types';


const actions: ActionTree<TemplatesState, RootState> = {
  setTemplatesIsLoading({ commit }, value: boolean) {
    commit('setTemplatesIsLoading', value);
  },

  async fetchTemplates({ commit }, { userId }): Promise<any> {
    commit('setTemplatesIsLoading', true);

    let data = [];

    try {
      const query = gql`query GetApplicationHRTemplate($filter: String) {
        getApplicationHRTemplateListing (filter: $filter) {
          edges {
            node {
              id
              template
              name
            }
          }
        }
      }`;
      const filterBuilder = new FilterBuilder();
      filterBuilder.addFilters(
        and(
          like('user__id', userId),
        ),
      );
      const resp = await defaultApolloClient.query({ query, variables: { filter: filterBuilder.build() }, fetchPolicy: 'network-only' });
      data = resp.data?.['getApplicationHRTemplateListing']?.edges?.map(
        ({ node }: any) => node
      );
    } catch (e) {
      console.error(e);
    }

    commit('setTemplates', data || []);
    commit('setTemplatesIsLoading', false);
    return data;
  },

  async createTemplate({}, { name, data, userId }): Promise<any> {
    let res = null;
    try {
      const mutation = gql`
        mutation {
          createApplicationHRTemplate(
            key: "${Date.now()}"
            path: "/FMLHR/Шаблоны заявок"
            input: {
              name: "${name}"
              template: "${JSON.stringify(data).replaceAll('\\"', '').replaceAll('"', '\\"')}"
                user: {
                    id: ${userId}
                    type: "object"
                }
              }
          ) {
            success
            message
          }
        }`;
      const resp = await defaultApolloClient.mutate({ mutation, variables: {} });
      res = resp.data?.['createApplicationHRTemplate'];
    } catch (e) {
      console.error(e);
    }
    return res;
  },

  async updateTemplate({}, { templateId, data }): Promise<any> {
    let res = null;
    try {
      const mutation = gql`mutation {
          updateApplicationHRTemplate(
            id: ${templateId}
            input: {
              template: "${JSON.stringify(data).replaceAll('"', '\\"')}"
            }
          ) {
            success
            message
          }
        }`;
      const resp = await defaultApolloClient.mutate({ mutation, variables: {} });
      res = resp.data?.['updateApplicationHRTemplate'];
    } catch (e) {
      console.error(e);
    }
    return res;
  },

  async deleteTemplate({}, templateId): Promise<any> {
    let res = null;
    try {
      const mutation = gql`
        mutation {
          deleteApplicationHRTemplate(
            id: ${templateId}
          ) {
            success
            message
          }
        }
      `;
      const resp = await defaultApolloClient.mutate({ mutation, variables: {} });
      res = resp.data?.['deleteApplicationHRTemplate'];
    } catch (e) {
      console.error(e);
    }
    return res;
  },
};

export default actions;
